import { render, staticRenderFns } from "./SystemComponentInfo.vue?vue&type=template&id=0a6f455a&"
import script from "./SystemComponentInfo.vue?vue&type=script&lang=js&"
export * from "./SystemComponentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports